import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Container, Row } from 'react-bootstrap';
import "./Recharge_now.css";
import Common_section_heading from '../../common_components/common_heading/common_section_heading/Common_section_heading';

const Recharge_now = () => {
  const plans = [
    {
      id: 1,
      operator: "Airtel Prepaid",
      number: "8864732301",
      plan: "289",
      expiry: "15 sep 2025",
    },
    {
      id: 2,
      operator: "Airtel Prepaid",
      number: "8864732301",
      plan: "289",
      expiry: "15 sep 2025",
    }
  ];
  return (
    <section className='recharge_section section_margin'>
      <Container>
        <Common_section_heading title="RECHARGE EXPIRING SOON!" subTitle="Keep your services active! Recharge before it expires" />
        <Row>
          {plans.map((items) => (
            <Col md={6} sm={12} key={items.id}>

              <div className='recharge_card'>

                <div className='logo'>
                  <img src='./assets/images/home/services/recharge_now/airtel_logo.png' alt='operator' className='operator_logo' />
                </div>
                <div className='operator_text'>
                  <h6 className='opertor'>{items.operator}</h6>
                  <p className='number'>{items.number}</p>
                </div>
                <div className='arrow-icon'>
                  <FontAwesomeIcon icon={faAngleRight} />
                </div>

              </div>

              <div className='plan_warning'>⚠️ Plan of ₹ 289 expires on 15 sep 2025</div>
            </Col>
          )
          )}
        </Row>
      </Container>
    </section>
  )
}

export default Recharge_now;